<template>
  <div>
    <SiteHeader/>
    <main class="coinsurf-signup">
      <div class="coinsurf-signup-content d-none d-md-flex">
        <div class="left-side text-center" v-if="getOS() === 'windows'">
          <img class="img-fluid mb-4 mb-lg-5" src="imgs/signup/windows-lab.png" alt="windows image" />
          <h3 class="mb-0">Download CoinSurf</h3>
          <p>Download CoinSurf for Windows and Get Started!</p>
          <div class="app-btn">
            <a href="https://coinsurf.com/downloads/v1.1.2-win/coinsurf-1.1.2.exe" class="main-btn" download>
              <svg class="me-2" style="position: relative; top: -3px" width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.687 0.777266C13.687 1.87906 13.1965 2.98085 12.5032 3.77492C11.7675 4.65506 10.4945 5.30925 9.48231 5.30925C9.36638 5.30925 9.25045 5.29419 9.17911 5.28128C9.16573 5.22748 9.13675 5.05963 9.13675 4.89177C9.13675 3.77492 9.72978 2.67313 10.3652 1.9759C11.1744 1.06993 12.5166 0.385613 13.6447 0.344727C13.6736 0.469539 13.687 0.624479 13.687 0.777266ZM17.6645 7.71692C17.6922 7.69937 17.7112 7.68733 17.7201 7.68069C16.2174 5.60191 13.9345 5.54596 13.2991 5.54596C12.3271 5.54596 11.4569 5.87873 10.7257 6.15838C10.1957 6.36107 9.73865 6.53586 9.36861 6.53586C8.95959 6.53586 8.49132 6.35333 7.9688 6.14967C7.30936 5.89263 6.56351 5.60191 5.74132 5.60191C2.96791 5.60191 0.149902 7.82056 0.149902 12.0039C0.149902 14.6121 1.19105 17.3601 2.47966 19.129C3.59215 20.6354 4.55972 21.862 5.94643 21.862C6.60394 21.862 7.08603 21.6646 7.59303 21.457C8.1553 21.2268 8.74822 20.984 9.64506 20.984C10.5515 20.984 11.0931 21.212 11.6153 21.4319C12.1013 21.6365 12.5705 21.834 13.3013 21.834C14.8173 21.834 15.8139 20.5105 16.7681 19.185C17.8382 17.6786 18.2863 16.2002 18.2997 16.1314C18.2128 16.1034 15.3078 14.9736 15.3078 11.7801C15.3078 9.20865 17.2882 7.95509 17.6645 7.71692Z" fill="#fff" />
              </svg>
              <span>Download for Windows</span>
            </a>
          </div>
        </div>
        <div class="left-side text-center" v-else>
          <img class="img-fluid mb-4 mb-lg-5" src="imgs/signup/mac-lab.png" alt="windows image" />
          <h3 class="mb-0">Download CoinSurf</h3>
          <p>Download CoinSurf for Windows and Get Started!</p>
          <div class="app-btn">
            <a href="https://coinsurf.com/downloads/v1.0.3-mac/coinsurf-1.0.3-arm64.pkg" class="main-btn" download>
              <svg class="me-2" style="position: relative; top: -3px" width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.687 0.777266C13.687 1.87906 13.1965 2.98085 12.5032 3.77492C11.7675 4.65506 10.4945 5.30925 9.48231 5.30925C9.36638 5.30925 9.25045 5.29419 9.17911 5.28128C9.16573 5.22748 9.13675 5.05963 9.13675 4.89177C9.13675 3.77492 9.72978 2.67313 10.3652 1.9759C11.1744 1.06993 12.5166 0.385613 13.6447 0.344727C13.6736 0.469539 13.687 0.624479 13.687 0.777266ZM17.6645 7.71692C17.6922 7.69937 17.7112 7.68733 17.7201 7.68069C16.2174 5.60191 13.9345 5.54596 13.2991 5.54596C12.3271 5.54596 11.4569 5.87873 10.7257 6.15838C10.1957 6.36107 9.73865 6.53586 9.36861 6.53586C8.95959 6.53586 8.49132 6.35333 7.9688 6.14967C7.30936 5.89263 6.56351 5.60191 5.74132 5.60191C2.96791 5.60191 0.149902 7.82056 0.149902 12.0039C0.149902 14.6121 1.19105 17.3601 2.47966 19.129C3.59215 20.6354 4.55972 21.862 5.94643 21.862C6.60394 21.862 7.08603 21.6646 7.59303 21.457C8.1553 21.2268 8.74822 20.984 9.64506 20.984C10.5515 20.984 11.0931 21.212 11.6153 21.4319C12.1013 21.6365 12.5705 21.834 13.3013 21.834C14.8173 21.834 15.8139 20.5105 16.7681 19.185C17.8382 17.6786 18.2863 16.2002 18.2997 16.1314C18.2128 16.1034 15.3078 14.9736 15.3078 11.7801C15.3078 9.20865 17.2882 7.95509 17.6645 7.71692Z" fill="#fff" />
              </svg>
              <span>Download for Mac</span>
            </a>
          </div>
        </div>
        <div class="right-side">
          <img class="img-fluid" src="imgs/signup/coin-icon-bg.png" alt="coin-icon" />
          <h1 class="mb-3 mb-lg-4">Join the <span>CoinSurf</span> community</h1>
          <p class="desc">Earn passive income by simply running the CoinSurf application and sharing your unused internet.</p>
          <p class="text">For every GB of traffic used on your network, CoinSurf will pay you $0.10</p>
        </div>
      </div>
      <div class="signup-mobile d-md-none">
        <div class="container">
          <div class="signup-mobile-content">
            <h2 class="mb-3">Download CoinSurf</h2>
            <p class="desc">Switch to your Mac OS or Windows device to begin downloading CoinSurf App</p>
            <img class="img-fluid" src="imgs/signup/signup-mobile.png" alt="signup" />
            <p class="text">Already have an account? <router-link :to="{name: 'login'}" class="text-decoration-underline">Sign In</router-link></p>
          </div>

          <p class="footer-text">For every GB of traffic used on your network, CoinSurf will pay you $0.10</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import SiteHeader from "@/components/partials/SiteHeader"
export default {
  name: "Register",
  components: {SiteHeader},
  data() {
    return {
      form: {
        username: '',
        email: '',
        password: ''
      }
    }
  },
  methods: {
    getOS() {
      if (window.navigator.userAgent.toLowerCase().indexOf("mac") > 0) {
        return 'mac'
      }

      return 'windows'
    },
  }
}
</script>

<style scoped>
@import '/public/css/signup.css';
</style>
